import React, {useState, useEffect} from 'react';
import Button from "../../../components/button";
import Breadcrumbs from "../../../components/breadcrumbs";
import Input from "../../../components/input";
import {Link, useHistory, useParams} from "react-router-dom";
import {useDispatch, useSelector} from 'react-redux';
import "./create.scss";
import {
    update_group,
    UPDATE_GROUP,
    clear_user_module,
    get_all_groups
} from '../../../redux/users';
import {ToastContainer, toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Footer from "../../../components/footer";
import Select from "react-select";
import LoadingSpinner from "../../../components/loading-spinner";

const UpdateGroup = () => {
    const {id} = useParams();
    const {token} = useSelector((state) => state.users_module.login.data) || null;

    const dispatch = useDispatch();
    const history = useHistory();
    const _get_all_permissions = useSelector((state) => state.users_module._get_all_permissions);
    const _get_all_groups = useSelector((state) => state.users_module._get_all_groups);
    const _update_group = useSelector((state) => state.users_module._update_group);

    const [permission, setPermission] = useState([]);
    const [permissionOptions, setPermissionOptions] = useState([]);
    const [permissionSelect, setPermissionSelect] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const [form, setForm] = useState({
        nombre: "",
        permisos: [],
    });

    useEffect(() => {
        if (_get_all_groups.data.datos) {
            // eslint-disable-next-line
            _get_all_groups.data.datos.map((item) => {
                if (item.id === parseInt(id)) {
                    let permisos = [];
                    let permisoSelect = [];
                    // eslint-disable-next-line
                    item.permisos.map((it) => {
                        permisos.push({codigo: it.codigo});
                        permisoSelect.push({value: it.codigo, label: it.nombre, model: it.modelo});
                    })
                    setForm({nombre: item.nombre, permisos: permisos});
                    setPermissionSelect(permisoSelect);
                }
            });
        }
    }, [_get_all_groups, id]);

    useEffect(() => {
        if (_update_group.status === 200) {
            dispatch(clear_user_module(UPDATE_GROUP));
            history.push("/roles");
            dispatch(get_all_groups(token));
            setIsLoading(false);
        } else if (_update_group.status !== 0) {
            dispatch(clear_user_module(UPDATE_GROUP));
            toast.error(_update_group.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
    }, [_update_group, dispatch, history, token]);

    useEffect(() => {
        if (_get_all_permissions.data) {
            if (_get_all_permissions.data.datos !== undefined) {
                setPermission(_get_all_permissions.data.datos)
                let datos = []
                // eslint-disable-next-line
                _get_all_permissions.data.datos.map((item) => {
                    datos.push({
                        label: item.nombre,
                        model: item.modelo,
                        value: item.codigo,
                    })
                })
                datos.unshift({
                    value: "ALL",
                    label: "TODOS",
                })
                setPermissionOptions(datos);
            }
        }
    }, [_get_all_permissions]);

    const handleChangeSelect = (e) => {
        let all = e.filter(x => x.value === "ALL")
        if (all.length > 0) {
            setPermissionSelect(all)
        } else {
            setPermissionSelect(e);
        }
    };

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        });
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        let all = permissionSelect.filter(x => x.value === "ALL")

        if (all.length > 0) {
            form.permisos = permission;

        } else {
            let array = permissionSelect.map((item) => {
                return {
                    nombre: item.label,
                    modelo: item.model,
                    codigo: item.value,
                };
            });
            form.permisos = array;
        }
        if (form.nombre === "") {
            toast.error("Debe ingresar el nombre del grupo", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (form.permisos.length === 0) {
            toast.error("Debe seleccionar al menos un permiso", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }

        dispatch(update_group(form, id, token));
    }

    return (
        <div className="app-content content">
            <div className="content-overlay"/>
            {isLoading && <LoadingSpinner/>}
            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Roles"
                            items={[
                                {label: "Lista", link: "/roles"},
                            ]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div className="row">
                        <div className="col-12">
                            <form className="card" onSubmit={handleSubmit}>
                                <div className="card-header">
                                    <h4 className="card-title">Modificar Rol</h4>
                                </div>
                                <div className="card-body">
                                    <div><ToastContainer/></div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <Input
                                                label="nombre"
                                                name="nombre"
                                                onChange={handleChange}
                                                value={form.nombre}
                                            />
                                        </div>
                                        <div className="col-md-12 mt-2">
                                            <div className="form-group">
                                                <label>Permisos</label>
                                                <Select
                                                    options={permissionOptions}
                                                    isMulti={true}
                                                    onChange={handleChangeSelect}
                                                    value={permissionSelect}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="card-footer button_responsive">
                                    <Link to="/roles"
                                          className="btn btn-outline-dark magin_button button_responsible">
                                        Cancelar
                                    </Link>
                                    <Button type="submit" text="Guardar" classes="button_responsible" theme="calendar"
                                            disabled={isLoading}/>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    );
}
export default UpdateGroup;
